import React, { useState } from "react";
import Swal from 'sweetalert2';
import { Form, Button, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import BaseUrl from '../../ApiServices/BaseUrl';
import { useNavigate } from 'react-router-dom';
import logo from '../../Pages/Images/GudnetNewLogo.webp'


const Login = ({ onSuccess }) => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate(); // Add this at the top inside your component

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const res = await fetch(`${BaseUrl}/login`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email, password }),
            });

            const data = await res.json();

            if (!res.ok) {
                setErrorMsg(data.message || "Login failed");
            } else {
                localStorage.setItem("user", JSON.stringify(data.user));

                await Swal.fire({
                    title: 'Login Successful!',
                    text: `Welcome back, ${data.user.first_name}!`,
                    icon: 'success',
                    confirmButtonColor: '#28a745',
                    confirmButtonText: 'Continue'
                });

                if (onSuccess) {
                    onSuccess();
                }

                // ✅ Navigate to /viewjobs after login
                navigate('/viewjobs');
            }
        } catch (error) {
            console.error("Login error:", error);
            setErrorMsg("Network error or server is down");
        } finally {
            setLoading(false);
        }
    };



    return (
        <div className="login-popup-container">
            {/* Logo and Close */}
            <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="d-flex align-items-center">
                    <img
                        src={logo}
                        alt="Gulf Worker Logo"
                        className="me-2 login-logo-gulfworker"
                    />
                </div>
            </div>

            <hr className="mb-4" style={{ borderTop: "3px solid #f8b400", marginTop: "-10px" }} />

            {/* Text */}
            <div className="text-center mb-4">
                <p className="text-muted mb-1">Please enter your details to log in</p>
                <h5 className="fw-bold">Welcome Back !!!</h5>
            </div>

            {/* Error */}
            {errorMsg && <div className="alert alert-danger py-1">{errorMsg}</div>}

            {/* Form */}
            <Form onSubmit={handleLogin}>
                {/* Email */}
                <Form.Group className="mb-3">
                    <div className="input-icon">
                        <i className="bi bi-envelope-fill icon"></i>
                        <Form.Control
                            type="email"
                            placeholder="Email"
                            className="input-with-icon"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>
                </Form.Group>

                {/* Password */}
                <Form.Group className="mb-3 position-relative">
                    <div className="input-icon">
                        <i className="bi bi-lock-fill icon"></i>
                        <Form.Control
                            type={showPassword ? "text" : "password"}
                            placeholder="Password"
                            className="input-with-icon pe-5"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                        <i
                            className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"} eye-icon`}
                            onClick={() => setShowPassword(!showPassword)}
                            style={{
                                position: "absolute",
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                cursor: "pointer",
                                color: "#6c757d"
                            }}
                        ></i>
                    </div>
                </Form.Group>

                {/* Remember + Forgot */}
                <Row className="mb-4 align-items-center">
                    <Col xs={6}>
                        <Form.Check type="checkbox" label="Remember me" />
                    </Col>
                    <Col xs={6} className="text-end">
                        <a href="#" className="text-success text-decoration-none fw-semibold">
                            Forgot Password ?
                        </a>
                    </Col>
                </Row>

                {/* Login Button */}
                <Button
                    className="w-100 login-btn"
                    variant="success"
                    type="submit"
                    disabled={loading}
                >
                    {loading ? 'Logging in...' : 'LOG IN'}
                </Button>
            </Form>

            <div className="mt-3 text-center">
                <p className="small">Don't have an account?
                    <button
                        className="btn btn-link p-0 ms-1 text-primary"
                        onClick={() => {
                            if (onSuccess) onSuccess();
                            // This would need to be handled by parent component to switch to register
                        }}
                    >
                        Register here
                    </button>
                </p>
            </div>
        </div>
    );
};

export default Login;